// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".time-ago--precv{font-size:.75rem}.time-ago--precv.muted--RpfMc{color:#96a0b4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"time-ago": "time-ago--precv",
	"muted": "muted--RpfMc"
};
export default ___CSS_LOADER_EXPORT___;
